export var CanvasElementType;
(function (CanvasElementType) {
    CanvasElementType["SHAPE"] = "shape";
    CanvasElementType["BRUSH"] = "brush";
    CanvasElementType["CONNECTOR"] = "connector";
    CanvasElementType["TEXT"] = "text";
    CanvasElementType["GROUP"] = "group";
})(CanvasElementType || (CanvasElementType = {}));
export function isCanvasElementType(type) {
    return type.toLocaleUpperCase() in CanvasElementType;
}
//# sourceMappingURL=edgeless-element.js.map